module.exports = __webpack_public_path__ + "static/media/logo.ccd1a346.png";